import { CreateTransient } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { styled } from "styled-components";

type IcbtExerciseLabelProps = {
  color: keyof typeof defaultTheme.COLORS;
  icon: {
    url: string;
  };
  label: string;
};

export const IcbtExerciseLabel = (props: IcbtExerciseLabelProps) => {
  return (
    <IconContainer $color={props.color}>
      {props.label}
      <Icon src={props.icon.url} alt={props.label} />
    </IconContainer>
  );
};

const IconContainer = styled.div<
  CreateTransient<Pick<IcbtExerciseLabelProps, "color">>
>`
  display: flex;
  width: max-content;
  padding: ${defaultTheme.SPACING.XS} ${defaultTheme.SPACING.SM};
  justify-content: center;
  align-items: center;
  gap: ${defaultTheme.SPACING.XS};
  border-radius: ${defaultTheme.BORDER_RADIUS.XL};
  background-color: ${(p) => defaultTheme.COLORS[p.$color ?? "PRIMARY_LIGHT"]};
`;

const Icon = styled.img`
  width: 1rem;
  height: 1rem;
`;
